module.exports = __webpack_public_path__ + "img/noticias.1533dc2a.jpg";